import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "bg-white flex items-center justify-center py-4 px-6"
}
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col items-center justify-center"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-sm" }, "Загрузка данных...", -1)
const _hoisted_4 = {
  key: 1,
  class: "flex flex-col items-center justify-center text-red-500"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "При получении данных произошла ошибка", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "py-4 px-6 bg-white mb-3 flex items-center justify-between" }
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Выше нормы себестоимости", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1)
const _hoisted_13 = { class: "bg-white py-4 px-6 grid grid-cols-2 gap-2" }
const _hoisted_14 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-semibold" }, "Номер РПП", -1)
const _hoisted_16 = { class: "text-sm" }
const _hoisted_17 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-semibold" }, "Дата РПП", -1)
const _hoisted_19 = { class: "text-sm" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-2 gap-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-semibold" }, "Вид перевозки"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-sm" }, "LTL")
], -1)
const _hoisted_21 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-semibold" }, "Направление", -1)
const _hoisted_23 = { class: "text-sm" }
const _hoisted_24 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-semibold" }, "Номер акта", -1)
const _hoisted_26 = { class: "text-sm" }
const _hoisted_27 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-semibold" }, "Дата акта", -1)
const _hoisted_29 = { class: "text-sm" }
const _hoisted_30 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-semibold" }, "Дата с", -1)
const _hoisted_32 = { class: "text-sm" }
const _hoisted_33 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-semibold" }, "Дата по", -1)
const _hoisted_35 = { class: "text-sm" }
const _hoisted_36 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-semibold" }, "Перевозчик", -1)
const _hoisted_38 = { class: "text-sm" }
const _hoisted_39 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-semibold" }, "Стоимость перевозки", -1)
const _hoisted_41 = { class: "text-sm" }
const _hoisted_42 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-semibold" }, "ТТН", -1)
const _hoisted_44 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_45 = { key: 0 }
const _hoisted_46 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_47 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-semibold" }, "Тг/кг", -1)
const _hoisted_49 = { class: "text-sm" }
const _hoisted_50 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-semibold" }, "Автор", -1)
const _hoisted_52 = { class: "text-sm" }
const _hoisted_53 = { class: "bg-white p-6 mt-6" }
const _hoisted_54 = {
  key: 1,
  class: "whitespace-nowrap"
}
const _hoisted_55 = {
  key: 2,
  class: "whitespace-nowrap"
}
const _hoisted_56 = {
  key: 3,
  class: "whitespace-nowrap"
}
const _hoisted_57 = {
  key: 0,
  class: "bg-white p-6 mt-6"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold uppercase text-blue-400 mb-3" }, " Комментарии по себестоимости ", -1)
const _hoisted_59 = {
  key: 0,
  class: "whitespace-nowrap"
}
const _hoisted_60 = {
  key: 1,
  class: "whitespace-nowrap"
}
const _hoisted_61 = {
  key: 2,
  class: "whitespace-nowrap"
}
const _hoisted_62 = {
  key: 1,
  class: "flex items-center justify-end mt-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_textarea = _resolveComponent("the-textarea")!
  const _component_new_modal = _resolveComponent("new-modal")!
  const _component_loader = _resolveComponent("loader")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_button_dropdown = _resolveComponent("button-dropdown")!
  const _component_new_table = _resolveComponent("new-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.state.is_submit)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 0,
          title: "Подтверждение РПП",
          loading: _ctx.state.is_submit_loading,
          onCancel: _ctx.toggleSubmit,
          onSubmit: _ctx.submit
        }, {
          default: _withCtx(() => [
            _createVNode(_component_the_textarea, {
              disabled: _ctx.state.is_submit_loading,
              autoheight: "",
              rows: 4,
              placeholder: "Комментарий",
              value: _ctx.state.comment,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.comment) = $event))
            }, null, 8, ["disabled", "value"])
          ]),
          _: 1
        }, 8, ["loading", "onCancel", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_loading || _ctx.state.is_failed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_loader, { class: "primary" }),
                _hoisted_3
              ]))
            : _createCommentVNode("", true),
          (_ctx.state.is_failed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
            : _createCommentVNode("", true)
        ]))
      : (_ctx.state.ltlRpp)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_page_title, {
                  title: `Просмотр РПП №${_ctx.state.ltlRpp.pbsNumber || '-'}`
                }, null, 8, ["title"]),
                _createVNode(_component_cheap, { class: "small ml-5" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.state.ltlRpp.status_name || 'Нет статуса'), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_cheap, { class: "small mx-2 whitespace-nowrap" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.state.ltlRpp.createdAtFrom) || '-'), 1)
                  ]),
                  _: 1
                }),
                (_ctx.state.ltlRpp.isAboveCostStandard)
                  ? (_openBlock(), _createBlock(_component_cheap, {
                      key: 0,
                      class: "red mr-3 small"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_button_dropdown, {
                  title: "Выберите действие",
                  class: "mr-2 whitespace-nowrap",
                  placement: "bottom",
                  "allowed-placements": ['bottom']
                }, {
                  default: _withCtx(() => [
                    (_ctx.state.ltlRpp.tripId)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: `/tms/trips/${_ctx.state.ltlRpp.tripId}`
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_new_button, { class: "NewButton--transparent InventoryTable__btn w-full" }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Открыть рейс ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true),
                    (_ctx.isOnEditStatus)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 1,
                          to: `/rpp/edit/${_ctx.ltl_rpp_id}`
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_new_button, { class: "NewButton--transparent InventoryTable__btn w-full" }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Редактировать ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, { to: "/rpp/ltl" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_new_button, { class: "NewButton--transparent" }, {
                      default: _withCtx(() => [
                        _hoisted_12,
                        _createTextVNode(" Назад ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.state.ltlRpp.pbsNumber || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.state.ltlRpp.pbsDate) || '-'), 1)
              ]),
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.state.ltlRpp.direction || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.state.ltlRpp.actNumber || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.formatDateFromBackend(_ctx.state.ltlRpp.actDate) || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.state.ltlRpp.createdAtFrom) || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.state.ltlRpp.createdAtTo) || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.state.ltlRpp.carrier || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.state.ltlRpp.costOfTransportation || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                (_ctx.state.ltlRpp)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.ltlRpp.ttns, (ttn, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `ttn-${ttn.id}`
                        }, [
                          _createVNode(_component_router_link, {
                            class: "text-blue-500 underline",
                            target: "_blank",
                            to: `/tms/ttns/${ttn.id}`
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(ttn.number), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]),
                          (i + 1 < _ctx.state.ltlRpp.ttns.length)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_45, ", "))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_46, "-"))
              ]),
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.state.ltlRpp.costPerWeight || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.state.ltlRpp.logist || '-'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createVNode(_component_new_table, {
                columns: _ctx.COLUMNS,
                rows: _ctx.state.ltlRpp.invoices,
                nowrap: "",
                "summary-row": ""
              }, {
                td: _withCtx(({ row, column }) => [
                  (column.key === 'invoiceNumber')
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        class: "text-blue-500 underline",
                        target: "_blank",
                        to: `/invoice/${row.invoiceId}`
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(row.invoiceNumber), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : (column.key === 'direction')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString(_ctx.state.ltlRpp.direction), 1))
                      : (column.key === 'sum')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString(_ctx.state.ltlRpp.allInvoicesCubature +
                                    _ctx.state.ltlRpp.allInvoicesWeight +
                                    _ctx.state.ltlRpp.allInvoicesCost +
                                    _ctx.state.ltlRpp.allInvoicesCostWithoutNDS), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(row[column.key] || '-'), 1))
                ]),
                "summary-invoiceId": _withCtx(() => [
                  _createTextVNode(" Итого суммарно ")
                ]),
                "summary-cubature": _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.state.ltlRpp.allInvoicesCubature), 1)
                ]),
                "summary-weight": _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.state.ltlRpp.allInvoicesWeight), 1)
                ]),
                "summary-cost": _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.state.ltlRpp.allInvoicesCost), 1)
                ]),
                "summary-costWithoutNds": _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.state.ltlRpp.allInvoicesCostWithoutNDS), 1)
                ]),
                "summary-totalCost": _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.state.ltlRpp.allInvoicesCost), 1)
                ]),
                _: 1
              }, 8, ["columns", "rows"])
            ]),
            (_ctx.state.comments.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                  _hoisted_58,
                  _createVNode(_component_new_table, {
                    columns: _ctx.COMMENTS_COLUMNS,
                    rows: _ctx.state.comments,
                    nowrap: "",
                    "is-centered": "",
                    "is-one-word": ""
                  }, {
                    td: _withCtx(({ row, column }) => [
                      (column.key === 'status')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                            _createVNode(_component_cheap, {
                              class: _normalizeClass(["small", {
                                        green: ['Подтверждено'].includes(row.status),
                                        yellow: ['На проверке у РТО'].includes(row.status),
                                    }])
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(row.status || 'Нет статуса'), 1)
                              ]),
                              _: 2
                            }, 1032, ["class"])
                          ]))
                        : (column.key === 'costOfTransportation')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString(row.costOfTransportation) + " тг.", 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(row[column.key] || '-'), 1))
                    ]),
                    _: 1
                  }, 8, ["columns", "rows"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.ltlRpp.status_id === 11)
              ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                  _createVNode(_component_new_button, { onClick: _ctx.toggleSubmit }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Подтвердить ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
  ]))
}